"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Error;
function Error(_ref) {
  var error = _ref.error;
  if (error) {
    return /*#__PURE__*/React.createElement("p", {
      id: "wpf-react-select-error"
    }, error);
  }
  return null;
}